import { render } from "./ViewAudioVersions.vue?vue&type=template&id=555fe85a&scoped=true"
import script from "./ViewAudioVersions.vue?vue&type=script&lang=js"
export * from "./ViewAudioVersions.vue?vue&type=script&lang=js"

import "./ViewAudioVersions.vue?vue&type=style&index=0&id=555fe85a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555fe85a"]])

export default __exports__